import { FileClient } from "@amazon-connect/file";
import type { AmazonConnectProvider } from "@amazon-connect/core";
import type { ClientModule } from "../types";

/** FileClient: attached file metadata and upload lifecycle. Request-only. */
export const fileModule: ClientModule = {
  id: "file",
  label: "File",
  pkg: "@amazon-connect/file",
  clientExport: "FileClient",
  kind: "request-only",
  create: (provider: AmazonConnectProvider) =>
    new FileClient({ provider }) as unknown as Record<string, unknown>,
  events: [],
  requests: [
    {
      name: "batchGetAttachedFileMetadata",
      args: [{ k: "params", type: "json", required: true }],
    },
    {
      name: "getAttachedFileUrl",
      args: [{ k: "params", type: "json", required: true }],
    },
    {
      name: "startAttachedFileUpload",
      args: [{ k: "data", type: "json", required: true }],
      mutating: true,
    },
    {
      name: "completeAttachedFileUpload",
      args: [{ k: "attachment", type: "json", required: true }],
      mutating: true,
    },
    {
      name: "deleteAttachedFile",
      args: [{ k: "data", type: "json", required: true }],
      mutating: true,
    },
  ],
};
